import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/** Auth0から渡ってくるクエリパラメータ */
type QueryParameterOnError = {
  client_id?: string;
  connection?: string;
  lang?: string;
  error?: string;
  // Access%20expired.
  // Callback%20URL%20mismatch.%20https%3A%2F%2Foauth.pstmn.io%2Fv1%2Fcallba2ck%3Fopt%3Dredirect%20is%20not%20in%20the%20list%20of%20allowed%20callback%20URLs
  error_description?: string;
  tracking?: string;
};

@Component({
  selector: 'app-auth0-error',
  templateUrl: './auth0-error.component.html',
  styleUrls: ['./auth0-error.component.css'],
})
export class Auth0ErrorComponent implements OnInit {
  private params?: QueryParameterOnError;
  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    // Auth0から渡ってくるクエリパラメータを取得
    const queryParams = this.activatedRoute.snapshot
      .queryParams as QueryParameterOnError;

    this.params = queryParams;
  }

  /** 期限切れエラーか否かを返す */
  get isShowAccessExpired(): boolean {
    if (this.params?.error_description?.includes('expired')) {
      return true;
    }
    return false;
  }
}
